//验证手机号
export function phoneValidation(data){
    let reg = /^1[0-9]{10}$/; //验证规则
    let flag = reg.test(data); //true
    return flag;
}
//倒计时
export function events(verification_code_text,totalTime,canClick,fn){
    if (!canClick) return  //改动的是这两行代码
    canClick = false;
    verification_code_text = totalTime + 's';
    let clock = window.setInterval(() => {
        totalTime--;
        verification_code_text = totalTime + 's';
        if (totalTime < 0) {
            window.clearInterval(clock)
            verification_code_text = '重新发送';
            totalTime = 60;
            canClick = true;  //这里重新开启
        }
        fn(verification_code_text,totalTime,canClick);
    },1000)
}

/* 用于邮箱验证的函数 */
export function validateEmail (email) {
    // 邮箱验证正则
    let reg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
    return reg.test(email);
}